'use client';

import { getEnvironmentConfig } from '@/utils/common/environment';
import React from 'react';
export default function AuthLayout({
  children
}: Readonly<{
  children: React.ReactNode;
}>) {
  const {
    backgroundImageLogin
  } = getEnvironmentConfig();
  return <main data-sentry-component="AuthLayout" data-sentry-source-file="AuthLayout.tsx">
      <div className="h-screen w-full bg-cover bg-no-repeat" style={{
      backgroundImage: backgroundImageLogin
    }}>
        {children}
      </div>
    </main>;
}